export async function ensureMediaAlbum(mediaPlugin, albumName) {
  if (!mediaPlugin?.getAlbums || !mediaPlugin?.createAlbum) {
    throw new Error('Native media album APIs are unavailable');
  }

  const normalizedName = String(albumName || '').trim();
  if (!normalizedName) throw new Error('Album name is required');

  const findAlbum = async () => {
    const response = await mediaPlugin.getAlbums();
    return (response?.albums || []).find(album =>
      String(album?.name || '').localeCompare(normalizedName, undefined, { sensitivity: 'accent' }) === 0
    );
  };

  const existing = await findAlbum();
  if (existing?.identifier) return existing.identifier;

  let createError = null;
  try {
    await mediaPlugin.createAlbum({ name: normalizedName });
  } catch (error) {
    // Another app session may have created the album between getAlbums() and
    // createAlbum(). Re-read before deciding that creation really failed.
    createError = error;
  }

  const created = await findAlbum();
  if (created?.identifier) return created.identifier;
  if (createError) throw createError;
  throw new Error(`Media album "${normalizedName}" was not returned after creation`);
}
